export const CARGAR_ASIENTOCONT = 'CARGAR_ASIENTOCONT';
export const SELECCIONAR_CUENTACONTABLE = 'SELECCIONAR_CUENTACONTABLE';
export const CARGAR_INDICADORCC = 'CARGAR_INDICADORCC';
export const CARGAR_CATALOGOCUENTAS = 'CARGAR_CATALOGOCUENTAS';
export const CARGAR_CTACONTABLE = 'CARGAR_CTACONTABLE';
export const ESTABLECER_CTACONTABLE = 'ESTABLECER_CTACONTABLE';
export const CARGAR_PLANESCONTABLES = 'CARGAR_PLANESCONTABLES';